import { createLayupClient } from './layupApi';

export const getPricelistById = async (id: string): Promise<any> => {
  const client = createLayupClient();
  const response = await client.get(`v1/pricelists/${id}`);
  return response.data;
};
